import { render, staticRenderFns } from "./StorySelector.vue?vue&type=template&id=45a44693&scoped=true"
import script from "./StorySelector.vue?vue&type=script&lang=js"
export * from "./StorySelector.vue?vue&type=script&lang=js"
import style0 from "./StorySelector.vue?vue&type=style&index=0&id=45a44693&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a44693",
  null
  
)

export default component.exports